export const INIT_CHECKOUT_SESSION_KEY = 'initCheckoutSession'
export const PAYMENT_ID_KEY = 'paymentId'
export const CHECKOUT_BOOKING_IDS_KEY = 'checkoutBookingIds'

export const CONTACT_FORM_FIRST_NAME_KEY = 'contactFormFirstName'
export const CONTACT_FORM_LAST_NAME_KEY = 'contactFormLastName'
export const CONTACT_FORM_EMAIL_KEY = 'contactFormEmail'
export const CONTACT_FORM_PHONE_KEY = 'contactFormPhone'
export const CONTACT_FORM_COMPANY_KEY = 'contactFormCompany'
export const CONTACT_FORM_NEWSLETTER_KEY = 'contactFormNewsletter'
